import { useState } from "react";
import { GrDocumentUpload } from "react-icons/gr";
import { FiFileText, FiTrash2 } from "react-icons/fi";

function ResumeUpload({ onUpload, disabled }) {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    // File size and type validation - only PDF and DOC, max 3MB
    const allowed = ["application/pdf", "application/msword"];
    if (!allowed.includes(selected.type)) {
      alert("Invalid file type. Only PDF and DOC files allowed.");
      return;
    }

    if (selected.size > 3 * 1024 * 1024) {
      alert("File too large. Max 3MB.");
      return;
    }

    setFile(selected);
    if (onUpload) onUpload(selected);
  };

  const removeFile = () => {
    setFile(null);
    if (onUpload) onUpload(null);
  };

  const formatSize = (size) => (size / 1024 / 1024).toFixed(2) + " MB";

  return (
    <div className={`space-y-3 ${disabled ? "opacity-50 pointer-events-none" : ""}`}>
      <label className="text-sm font-semibold text-gray-700">Resume *</label>

      <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 transition hover:border-blue-500">

        {!file ? (
          <div className="flex flex-col items-center text-center gap-4">

            <div className="text-3xl text-gray-400">
              <GrDocumentUpload />
            </div>

            <div>
              <p className="font-medium text-gray-700">Upload your resume</p>
              <p className="text-sm text-gray-500">PDF or DOC (max 3MB)</p>
            </div>

            <label className={`bg-black text-white px-5 py-2.5 rounded-lg text-sm hover:opacity-90 transition ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
              Choose File
              <input type="file" accept=".pdf,.doc" className="hidden" onChange={handleFileChange} disabled={disabled} />
            </label>

          </div>
        ) : (
          <div className="space-y-4">

            <div className="flex items-center justify-between bg-gray-50 border rounded-xl p-4">

              <div className="flex items-center gap-3">
                <div className="text-xl text-gray-600">
                  <FiFileText />
                </div>

                <div>
                  <p className="text-sm font-medium text-gray-800">{file.name}</p>
                  <p className="text-xs text-gray-500">{formatSize(file.size)}</p>
                </div>
              </div>

              <button type="button" onClick={removeFile} disabled={disabled} aria-label="Remove file" className="p-2 rounded-lg hover:bg-red-50 text-red-500 disabled:opacity-50 disabled:cursor-not-allowed">
                <FiTrash2 />
              </button>

            </div>

            <div className="flex justify-center">
              <label className={`border px-4 py-2 rounded-lg text-sm hover:bg-gray-100 transition ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
                Replace file
                <input type="file" accept=".pdf,.doc" className="hidden" onChange={handleFileChange} disabled={disabled} />
              </label>
            </div>

          </div>
        )}

      </div>
    </div>
  );
}

export default ResumeUpload;